// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YkTE6","input":"styles_input__KFq9e"};